<ion-content class="ion-padding m-comprovante-renda">
  <div class="m-comprovante-renda__header">
    <ion-button fill="clear" size="small" (click)="imprimir()">
      <ion-icon slot="start" name="print-outline"></ion-icon>
      Imprimir
    </ion-button>
    <ion-button color="dark" fill="clear" size="small" (click)="dismiss()">
      <ion-icon slot="icon-only" name="close-outline"></ion-icon>
    </ion-button>
  </div>


  <div id="print-container" class="m-comprovante-renda__content" [innerHTML]="htmlContent"></div>

</ion-content>